import { Icon } from '../component-library';
import { Flex } from '../2022-component-library/src/components/shared';
import styled from '@emotion/styled';
import { LocalVideo, RemoteVideo } from '../2022-component-library/src/components/shared';
import { calibrationConstants } from '../helpers/calibration-constants';

const SmallScreenVideos = () => {
  return (
    <Flex width='75vw' gap='1rem' justifyContent='space-between' marginBottom='1rem'>
      <VideoContainer marginBottom='1rem'>
        <VideoRefreshOverlay>
          <Icon icon='loop2' size={15} color='white' />
        </VideoRefreshOverlay>
        <LocalVideo />
      </VideoContainer>
      <VideoContainer>
        <RemoteVideo />
      </VideoContainer>
    </Flex>
  );
};

export default SmallScreenVideos;

const VideoContainer = styled.div`
  width: 240px;
  height: 160px;
  border-radius: ${calibrationConstants.VIDEO_BORDER_RADIUS}px;
  box-shadow: 0px 11px 22px #b9d5d5;
  position: relative;
  background-color: ${({ hidden }) => (hidden ? 'rgba(0, 0, 0, 0.5)' : '#fff')};
`;

const VideoRefreshOverlay = styled(Flex)`
  background-color: rgba(0, 0, 0, 0.2);
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin: 10px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  justify-content: center;
  align-items: center;

  &:hover {
    background-color: rgba(0, 0, 0, 0.3);
    cursor: pointer;
  }

  & svg {
    display: block !important;
  }
`;
